import { navigateListAction } from './navigateListAction';
/**
 * Either increments or decrements the previous highlighted index value.
 * This is used by the dropdown menu to correctly highlight the dropdown
 * option that has been focussed
 *
 * @param {Dispatch<DropdownReducerAction>} dispatch
 */
export var updateHighlightedOptionIndex = function (dispatch) { return function (key) {
    return dispatch(navigateListAction(key));
}; };
//# sourceMappingURL=updateHighlightedOptionIndex.js.map